import React, { useEffect } from 'react';
import '../styles/Newsletter.css';

const HTML = `
<div class="topbar">
    <div class="breadcrumb"><span>Cambérène</span><span class="sep">/</span><span>Admin</span><span class="sep">/</span><b>Newsletter</b></div>
    <div class="search"><span class="ic"></span><input type="text" placeholder="Chercher…" /><kbd>⌘ K</kbd></div>
    <div class="top-actions"><button class="icon-btn">⚏</button><button class="icon-btn">◉<span class="dot"></span></button><a class="top-cta" href="#"><span class="plus"></span> + Nouvelle édition</a></div>
  </div>
  <div class="content">

<div class="page-head">
  <div>
    <span class="eyebrow">Newsletter · Lettre du village · Mensuelle</span>
    <h1>La lettre,<br /><span class="ital">de Cambérène.</span></h1>
    <p class="sub">Édition mensuelle envoyée à 3 218 abonnés · taux d'ouverture 52 % · prochaine édition programmée pour le 1ᵉʳ juin.</p>
  </div>
  <div style="display:flex; gap:10px; align-items:center; flex-wrap:wrap">
    <div class="seg"><button class="on">Composer</button><button>Historique</button><button>Abonnés</button><button>Modèles</button></div>
    <button class="pill-btn">↗ Envoi test</button>
  </div>
</div>

<div class="kpis">
  <div class="kpi"><div class="lab"><span class="dot" style="background:#34A853"></span> Abonnés actifs</div><b>3 218</b><span class="delta up">▲ +218 / mois</span></div>
  <div class="kpi"><div class="lab"><span class="dot" style="background:#E76F51"></span> Ouverture moyenne</div><b>52<span class="unit">%</span></b><span class="delta up">▲ +4 pts</span></div>
  <div class="kpi"><div class="lab"><span class="dot" style="background:#1B6985"></span> Clic moyen</div><b>14<span class="unit">%</span></b><span class="delta up">▲ +1,2 pt</span></div>
  <div class="kpi dark"><div class="lab"><span class="dot" style="background:#E2CB91"></span> Édition · 1 Juin</div><b>J−12</b><span class="delta up" style="background:rgba(52,168,83,.2); color:#7CE39A">brouillon prêt</span></div>
</div>

<div class="hero-news">

  <section class="preview-card">
    <div class="body">
      <span class="lab"><i></i> Brouillon · Édition 06 · à valider</span>
      <h2>Mai à Cambérène — pirogues, finale, &amp; Grand Appel.</h2>
      <p class="sub">10 800 destinataires segmentés · envoi prévu 01 Juin · 09h00 GMT.</p>
    </div>

    <div class="mock-email">
      <div class="mh">
        <div class="from">Cambérène<small>contact@camberene.sn → vous</small></div>
        <small>1 Juin 2026 · 09:00</small>
      </div>
      <div class="cover"><div class="ti">Mai à Cambérène — pirogues, finale, &amp; Grand Appel.</div></div>
      <div class="mb">
        <div class="pre">Lettre du village · Édition #06</div>
        <p>Chères &amp; chers, le mois de mai a vu naître <b>vingt jeunes</b> du studio créatif, la <b>plage propre</b> battre son record de mobilisation et la <b>finale Navétane</b> approcher à grands pas. Voici l'essentiel.</p>
        <a class="btn" href="#">→ Lire l'édition complète</a>
      </div>
    </div>
  </section>

  <section style="display:flex; flex-direction:column; gap:18px">
    <div class="stat-card">
      <div class="top"><h3>Performance · 30 jours</h3><span class="lab">Édition #05</span></div>
      <div class="big-num">52<span style="font-family:var(--mono); font-size:.4em; color:var(--char-500); margin-left:6px">% OUVERTURE</span></div>
      <div class="lab">Moyenne industrie 21 % · vous êtes <b style="color:#1F7A3A">× 2,5</b></div>

      <div class="stat-bars">
        <div class="stat-bar-row"><span class="nm">Ouverture</span><span class="v">52<small>%</small></span><div class="bar"><i style="width:52%"></i></div></div>
        <div class="stat-bar-row"><span class="nm">Clic <small>moy. industrie 2,6 %</small></span><span class="v">14<small>%</small></span><div class="bar"><i class="ocean" style="width:14%"></i></div></div>
        <div class="stat-bar-row"><span class="nm">Désabonnement</span><span class="v">0,2<small>%</small></span><div class="bar"><i class="ok" style="width:8%"></i></div></div>
        <div class="stat-bar-row"><span class="nm">Partages externes</span><span class="v">8,4<small>%</small></span><div class="bar"><i style="width:34%"></i></div></div>
      </div>
    </div>

    <div style="background:linear-gradient(160deg, var(--sand-200), var(--sand-300)); border-radius:14px; padding:20px">
      <span class="eyebrow">Prochaine étape</span>
      <h3 style="font-family:var(--serif); font-weight:400; font-size:22px; margin:6px 0 8px; letter-spacing:-.005em">Valider le brouillon avant le 28 mai</h3>
      <p style="margin:0 0 14px; font-size:13.5px; color:var(--char-700); line-height:1.5">3 sections rédigées, 1 photo à ajouter, et un appel à dons à valider par la commission.</p>
      <div style="display:flex; gap:8px; flex-wrap:wrap">
        <a href="#" class="pill-btn on">✎ Continuer la rédaction</a>
        <a href="#" class="pill-btn">↗ Envoi test</a>
      </div>
    </div>
  </section>

</div>

<section class="panel" style="margin-bottom:24px">
  <div class="panel-head">
    <div>
      <h3>Segmenter l'envoi</h3>
      <p class="sub">L'édition #06 ciblera 4 segments — total 10 800 destinataires (3 218 actifs + relances).</p>
    </div>
    <button class="pill-btn">+ Segment</button>
  </div>

  <div class="segment-grid">
    <div class="segment on">
      <span class="check"></span>
      <b>Habitants vérifiés</b>
      <small>Sénégal · membres actifs &gt; 30j</small>
      <div class="v">2 240</div>
    </div>
    <div class="segment on">
      <span class="check"></span>
      <b>Diaspora abonnée</b>
      <small>France · Italie · USA · Espagne</small>
      <div class="v">762</div>
    </div>
    <div class="segment on">
      <span class="check"></span>
      <b>Talents publiés</b>
      <small>42 portraits · auteur + équipe</small>
      <div class="v">86</div>
    </div>
    <div class="segment on">
      <span class="check"></span>
      <b>Anciens lecteurs · relance</b>
      <small>Inactifs depuis 60 jours</small>
      <div class="v">130</div>
    </div>
    <div class="segment">
      <span class="check"></span>
      <b>Visiteurs simples</b>
      <small>Inscrits mais non vérifiés</small>
      <div class="v">412</div>
    </div>
    <div class="segment">
      <span class="check"></span>
      <b>Partenaires &amp; presse</b>
      <small>Médias, partenaires locaux</small>
      <div class="v">38</div>
    </div>
  </div>
</section>

<section class="panel campaign-table" style="margin-bottom:24px">
  <div class="panel-head">
    <div>
      <h3>Éditions précédentes</h3>
      <p class="sub">Historique des envois et performance.</p>
    </div>
    <div style="display:flex; gap:8px"><button class="pill-btn on">Toutes</button><button class="pill-btn">Mensuelles</button><button class="pill-btn">Spéciales</button></div>
  </div>

  <div style="overflow-x:auto">
    <table class="table">
      <thead><tr><th>Édition</th><th>Sujet</th><th>Envoyée</th><th>Destinataires</th><th>Ouverture</th><th>Clic</th><th>Statut</th><th></th></tr></thead>
      <tbody>
        <tr class="selected">
          <td style="padding-left:20px"><b>#06</b><small>Brouillon</small></td>
          <td><b>Mai à Cambérène — pirogues &amp; finale</b><small>Mensuelle · 4 sections</small></td>
          <td>—</td>
          <td><span class="v">10 800</span></td>
          <td>—</td>
          <td>—</td>
          <td><span class="status-pill warn">Brouillon</span></td>
          <td><div class="row-actions"><button>✎</button><button>⋯</button></div></td>
        </tr>
        <tr>
          <td><b>#05</b><small>Mensuelle</small></td>
          <td><b>Le studio créatif débarque à Cambérène</b><small>4 sections · 1 reportage</small></td>
          <td>01 Mai 2026</td>
          <td><span class="v">10 412</span></td>
          <td><span class="v">52<small>%</small></span></td>
          <td><span class="v">14<small>%</small></span></td>
          <td><span class="status-pill live">Envoyée</span></td>
          <td><div class="row-actions"><button>↗</button><button>⋯</button></div></td>
        </tr>
        <tr>
          <td><b>★</b><small>Spéciale</small></td>
          <td><b>Grand Appel — édition spirituelle</b><small>3 sections + vidéo</small></td>
          <td>18 Avr 2026</td>
          <td><span class="v">8 980</span></td>
          <td><span class="v">68<small>%</small></span></td>
          <td><span class="v">22<small>%</small></span></td>
          <td><span class="status-pill live">Envoyée</span></td>
          <td><div class="row-actions"><button>↗</button><button>⋯</button></div></td>
        </tr>
        <tr>
          <td><b>#04</b><small>Mensuelle</small></td>
          <td><b>Avril — l'ASC en demi-finale, archives 1962</b></td>
          <td>01 Avr 2026</td>
          <td><span class="v">10 142</span></td>
          <td><span class="v">48<small>%</small></span></td>
          <td><span class="v">13<small>%</small></span></td>
          <td><span class="status-pill live">Envoyée</span></td>
          <td><div class="row-actions"><button>↗</button><button>⋯</button></div></td>
        </tr>
        <tr>
          <td><b>#03</b><small>Mensuelle</small></td>
          <td><b>Mars — pirogues à l'aube &amp; Plage propre</b></td>
          <td>01 Mar 2026</td>
          <td><span class="v">9 868</span></td>
          <td><span class="v">47<small>%</small></span></td>
          <td><span class="v">12<small>%</small></span></td>
          <td><span class="status-pill live">Envoyée</span></td>
          <td><div class="row-actions"><button>↗</button><button>⋯</button></div></td>
        </tr>
        <tr>
          <td><b>#02</b><small>Mensuelle</small></td>
          <td><b>Février — nouvelle saison ASC, portraits</b></td>
          <td>01 Fév 2026</td>
          <td><span class="v">9 540</span></td>
          <td><span class="v">44<small>%</small></span></td>
          <td><span class="v">10<small>%</small></span></td>
          <td><span class="status-pill live">Envoyée</span></td>
          <td><div class="row-actions"><button>↗</button><button>⋯</button></div></td>
        </tr>
      </tbody>
    </table>
  </div>
</section>

<section class="panel">
  <div class="panel-head">
    <div>
      <h3>Modèles de mail</h3>
      <p class="sub">Composer rapidement, sans repartir de zéro.</p>
    </div>
    <button class="pill-btn">+ Modèle</button>
  </div>

  <div style="display:grid; grid-template-columns:repeat(4, 1fr); gap:14px">
    <div style="background:var(--bone-2); border-radius:12px; padding:18px"><span class="cat-pill sunset">Mensuelle</span><h4 style="font-family:var(--serif); font-weight:400; font-size:20px; line-height:1.1; margin:10px 0 6px">Lettre du mois</h4><p style="margin:0; font-size:13px; color:var(--char-700)">4 sections · photo de couverture · agenda · talents.</p></div>
    <div style="background:var(--bone-2); border-radius:12px; padding:18px"><span class="cat-pill gold">Spirituel</span><h4 style="font-family:var(--serif); font-weight:400; font-size:20px; line-height:1.1; margin:10px 0 6px">Spécial Grand Appel</h4><p style="margin:0; font-size:13px; color:var(--char-700)">Lecture rythmée · vidéo live · programme spirituel.</p></div>
    <div style="background:var(--bone-2); border-radius:12px; padding:18px"><span class="cat-pill ocean">Sport</span><h4 style="font-family:var(--serif); font-weight:400; font-size:20px; line-height:1.1; margin:10px 0 6px">Bulletin ASC</h4><p style="margin:0; font-size:13px; color:var(--char-700)">Résumé matchs · joueur du mois · prochains rendez-vous.</p></div>
    <div style="background:var(--bone-2); border-radius:12px; padding:18px"><span class="cat-pill ok">Mairie</span><h4 style="font-family:var(--serif); font-weight:400; font-size:20px; line-height:1.1; margin:10px 0 6px">Communiqué officiel</h4><p style="margin:0; font-size:13px; color:var(--char-700)">En-tête de la Mairie · signature du Maire.</p></div>
  </div>
</section>

  </div>
`;

const Newsletter = () => {
  useEffect(() => {
    // Filter chips behavior (shared pattern from mockups)
    const groups = document.querySelectorAll('.admin-page .seg, .admin-page .filterbar');
    const handler = (e) => {
      const c = e.target.closest('.chip, .seg button, .pill-btn');
      if (!c) return;
      const group = c.parentElement;
      if (!group) return;
      const siblings = group.querySelectorAll('.chip, button');
      let sameGroup = true;
      siblings.forEach((s) => { if (!group.contains(s)) sameGroup = false; });
      if (sameGroup) {
        siblings.forEach((s) => s.classList.remove('on'));
        c.classList.add('on');
      }
    };
    groups.forEach((g) => g.addEventListener('click', handler));
    return () => groups.forEach((g) => g.removeEventListener('click', handler));
  }, []);

  return (
    <div className="admin-page admin-page-newsletter" dangerouslySetInnerHTML={{ __html: HTML }} />
  );
};

export default Newsletter;
